(() => {
  const sale = window.PrintlitsSale;
  if (!sale) return;
  let ended = false;
  function restorePrices() {
    document.querySelectorAll('.pc-price,.printlits-family__price,.pl-hw-prices,.pl-related-price,.pl-search-price,.cart-item__discounted-prices,.pl-character-price,.pl-sticky-price').forEach(group => {
      const original = group.querySelector('s,.pl-hw-was');
      const price = group.querySelector('strong,.pl-hw-now');
      if (original && price && price.textContent.trim() !== original.textContent.trim()) price.textContent = original.textContent.trim();
    });
  }
  function finish() {
    if (ended || sale.isActive()) return;
    ended = true;
    document.documentElement.classList.add('pl-sale-ended');
    restorePrices();
    document.dispatchEvent(new CustomEvent('printlits:sale-ended'));
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; restorePrices(); });
    }).observe(document.body, {childList: true, subtree: true});
  }
  function schedule() {
    if (!sale.isActive()) { finish(); return; }
    setTimeout(schedule, Math.min(sale.endsAt - Date.now(), 2147483647));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once: true});
  else schedule();
  window.addEventListener('pageshow', () => { if (!sale.isActive()) finish(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && !sale.isActive()) finish(); });
  if (!customElements.get('printlits-sale-countdown')) customElements.define('printlits-sale-countdown', class extends HTMLElement {
    connectedCallback() {
      const tick = () => {
        const remaining = Math.max(0, Math.ceil((sale.endsAt - Date.now()) / 1000));
        if (!remaining) { this.hidden = true; clearInterval(this.timer); finish(); return; }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        this.querySelectorAll('[data-countdown-value]').forEach((node, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (node.textContent !== value) node.textContent = value;
        });
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
})();
